import { existingHeaders } from "./utils";
import { getAuthUrl } from "utils/env";

export const verificationService = {
  verify,
  verifyEmailChange,
  confirmEmailChange,
};

function verifyEmailChange(token) {
  const requestOptions = {
    method: "POST",
    headers: existingHeaders,
    body: JSON.stringify({ token: token }),
  };

  return fetch(
    getAuthUrl("/customer/email-change/verify"),
    requestOptions
  ).then(handleResponse);
}

function confirmEmailChange(token) {
  const requestOptions = {
    method: "POST",
    headers: existingHeaders,
    body: JSON.stringify({ token: token }),
  };

  return fetch(
    getAuthUrl("/customer/email-change/confirm"),
    requestOptions
  ).then(handleResponse);
}

function verify(token) {
  const requestOptions = {
    method: "POST",
    headers: existingHeaders,
    body: JSON.stringify({ token: token }),
  };

  return fetch(getAuthUrl("/customer/email/verification"), requestOptions).then(
    handleResponse
  );
}

function handleResponse(response) {
  if (!response.ok) {
    return Promise.reject(response.status);
  } else {
    return Promise.resolve(response);
  }
}
